import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Organisateur Redux States
import {
  GET_ORGANISATEURS,
  ADD_NEW_ORGANISATEUR,
  UPDATE_ORGANISATEUR,
} from "./actionType";

import {
  organisateurApiResponseSuccess,
  organisateurApiResponseError,
  addOrganisateurFail,
  addOrganisateurSuccess,
  updateOrganisateurSuccess,
  updateOrganisateurFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getOrganisateurs as getOrganisateursApi,
  addNewOrganisateur,
  updateOrganisateur,
} from "../../helpers/fakebackend_helper";

function* getOrganisateurs() {
  try {
    const response = yield call(getOrganisateursApi);
    yield put(organisateurApiResponseSuccess(GET_ORGANISATEURS, response));
  } catch (error) {
    yield put(organisateurApiResponseError(GET_ORGANISATEURS, error));
  }
}

function* onUpdateOrganisateur({ payload: organisateur }) {
  console.log(organisateur);
  try {
    const response = yield call(updateOrganisateur, organisateur);
    console.log(response);
    yield put(updateOrganisateurSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(updateOrganisateurFail(error));
  }
}

function* onAddNewOrganisateur({ payload: organisateur }) {
  try {
    console.log("organisateur: ", organisateur);
    const response = yield call(addNewOrganisateur, organisateur);
    yield put(addOrganisateurSuccess(response));
  } catch (error) {
    yield put(addOrganisateurFail(error));
  }
}

export function* watchGetOrganisateurs() {
  yield takeEvery(GET_ORGANISATEURS, getOrganisateurs);
}

export function* watchUpdateOrganisateur() {
  yield takeEvery(UPDATE_ORGANISATEUR, onUpdateOrganisateur);
}

export function* watchAddNewOrganisateur() {
  yield takeEvery(ADD_NEW_ORGANISATEUR, onAddNewOrganisateur);
}

function* organisateurSaga() {
  yield all([
    fork(watchGetOrganisateurs),
    fork(watchUpdateOrganisateur),
    fork(watchAddNewOrganisateur),
  ]);
}

export default organisateurSaga;
